import { Link, Outlet } from 'react-router-dom'

import TierBadge from '../../components/TierBadge.jsx'
import { HistoryProvider } from './historyStore.jsx'
import { useScrollToTopOnPush } from './scroll.js'

// The parent of every season view: the page, the provider, the docs link. P6-329c (GN-2c).
//
// ═══════════════════════════════════════════════════════════════════════════
// A PARENT ROUTE, SO WHAT IS READ IS KEPT WHILE SOMEBODY MOVES BETWEEN VIEWS
// ═══════════════════════════════════════════════════════════════════════════
//
// react-router keeps a parent route's element mounted while its children change, which is what lets the provider
// (`historyStore.jsx`) hold the list of seasons, the teams table and every file already read for exactly as long as
// somebody is inside Players, Leaders, Standings, Teams and the pages beneath them. Opening a player from the list does
// not read the index again; leaving for Tonight, or for the portal, throws it all away. There is no module-level cache
// to reset anywhere.
//
// TONIGHT IS NOT A CHILD OF THIS. It is its own route (`HoopsRoutes.jsx`) because it polls, and a poll must stop the
// moment its screen leaves, which is what unmounting is; and it needs none of what the provider holds.
//
// `docPath` IS DRAWN IN EVERY STATE, as `HoopsPanel.jsx` does it: a docs page does not depend on `/api/hoops/*`, and
// `doc-links.test.jsx` is the gate that says every hoops screen links to its page. The label is the panel's own words.

export default function SeasonShell({ docPath, tier, timeZone }) {
  useScrollToTopOnPush()
  return (
    <HistoryProvider timeZone={timeZone}>
      <article className="d2d-page d2d-hoopspage" data-testid="hoops-page">
        <div className="d2d-hoops">
          <Outlet />
          <div className="d2d-hoops__foot">
            {docPath ? (
              <Link className="d2d-portal__more d2d-micro" to={docPath}>
                How hoops works {'→'}
              </Link>
            ) : (
              <span />
            )}
            <TierBadge tier={tier} />
          </div>
        </div>
      </article>
    </HistoryProvider>
  )
}
